export default {
  sm: `
    데이터센터 IT창고의 핵심 자산인 서버들을 안전하고 효율적으로 관리하기 위해 개발한 로봇입니다. 2-5mm 단위의 정밀제어를 통해 사람의 개입 없이 안전하게 자산을 넣고 꺼낼 수 있으며, 자율운송 로봇 '가로'와 협업해 주고받을 수도 있습니다.
  `,
  xl: `
    데이터센터 IT창고의 핵심 자산인 서버들을 안전하고 효율적으로 
    관리하기 위해 개발한 로봇입니다. 2-5mm 단위의 정밀제어를 통해 
    사람의 개입 없이 안전하게 자산을 넣고 꺼낼 수 있으며, 
    자율운송 로봇 '가로'와 협업해 주고받을 수도 있습니다.
  `,
};
